// languagetools:disable
import { useApolloClient, useQuery } from '@apollo/client'
import { useActiveChannelSnapshot } from '@chain-zen/chat'
import { useMemo } from 'react'

import { POST_OFFER } from '../../../data/queries/offer'
import { MY_WORKSPACES } from '../../../data/queries/workspace'
import type { IPostOfferReturnType } from '../../../types/post'
import type { IMembership } from '../../../types/user'
import { MembershipStatus } from '../../../types/user'
import { CarrierView } from './carrier-view'
import { Header } from './header'
import { OfferDetails } from './offer-details'
import { OriginalPosterView } from './original-poster-view'

/**
 * Displays the details of a Offer chat
 */
export const OfferChatDetails = () => {
  const { channelDetail } = useActiveChannelSnapshot()
  const client = useApolloClient()

  const postData = useMemo(() => {
    const offerFromChannel = channelDetail?.offers?.[0]

    return {
      loadNumber: channelDetail?.loadNumber || '',
      offerID: offerFromChannel?.offerID,
      postID: channelDetail?.postID || '',
      postOwnerWorkspaceID: channelDetail?.postedByWorkspaceID || null,
      workspacename: channelDetail?.workspace?.workspacename || ''
    }
  }, [channelDetail])

  const { data: offer } = useQuery<{ postOffer: IPostOfferReturnType | null }>(POST_OFFER, {
    variables: { offerID: postData.offerID, postID: postData.postID }
  })

  const cachedWorkspaces = client.readQuery({
    query: MY_WORKSPACES
  })

  const myWorkspaces =
    cachedWorkspaces?.myWorkspaces && cachedWorkspaces?.myWorkspaces.length ? cachedWorkspaces?.myWorkspaces : null

  const isPostOwner =
    myWorkspaces?.some((myWorkspace: IMembership) => {
      if (myWorkspace?.workspace?.id === postData.postOwnerWorkspaceID) {
        return myWorkspace.status === MembershipStatus.ACTIVE
      }
      return false
    }) ?? false

  return (
    <div aria-label="offer-chat" className="w-full">
      <Header postData={{ ...postData }} />
      <div className="flex flex-col gap-4 p-4">
        {!!offer && !!offer.postOffer && <OfferDetails offer={offer.postOffer} />}
        {!isPostOwner && <CarrierView postID={postData.postID} />}
        {!!isPostOwner && <OriginalPosterView offer={offer?.postOffer || null} postID={postData.postID || ''} />}
      </div>
    </div>
  )
}
